import {IRouteProps} from "../../../ts/manager/view/ViewInterface";
import React, {useRef, useState} from "react";
import PostAddEditForm from "./partial/PostAddEditForm";
import {PostType} from "../../../ts/manager/post/PostManager";
import {getManager} from "../../../ts/manager/Manager";
import StateViewController from "../../vc/StateViewController";
import {assert} from "../../../ts/common/Assert";
import {getModelFactory} from "../../../ts/model-factory/ModelFactory";
import {dispatchRedirectHome, dispatchRedirectTo, dispatchResetRouteBaseURLs} from "../../../ts/event/DispatchEvent";

const PostEditPage = (props:IRouteProps) =>
{
    const formRef = useRef<PostAddEditForm|null>(null);

    const postType:PostType = getManager().navigation.model.routeIDs.post_type ?? "organisation"
    let organisationID = getManager().user.organisationID;
    const postID = (postType !== "organisation") ? (getManager().navigation.model.routeIDs.post_id ?? 0) : organisationID;

    const postModel = getModelFactory().postData.getPostDataModel(postType, true);
    const postChoice = postModel.choices[postID] ?? null;

    const [slug, setSlug] = useState<string>(() => {
        return postChoice?.slug ?? ""
    });

    const viewState = StateViewController({
        routeProps: props,
        dataModels: postModel,
        assert: postChoice
    })


    if(viewState.overrideView){
        return viewState.overrideView;
    }

    assert(postChoice);

    if(postChoice.slug !== slug){
        setSlug(postChoice.slug);
    }


    const getForm = ():PostAddEditForm|null =>
    {
        return (formRef.current as PostAddEditForm) ?? null;
    }

    const onSubmit = (submitType?: string) =>
    {
        if(submitType === "delete"){
            const publicPostDataModel = getModelFactory().postData.getPostDataModel(postType, false);
            publicPostDataModel.resetPopulated();
            const listChoice = getModelFactory().postRoute.getDefaultModel(postType)?.choices.list ?? null;
            if(listChoice){
                dispatchRedirectTo(listChoice.getHref(), true);
            } else {
                dispatchRedirectHome(true);
            }
            return;
        }
        const choice = getForm()?.choice ?? null;
        if(!choice){
            return;
        }
        if(slug !== choice.slug){
            setSlug(choice.slug)
            dispatchResetRouteBaseURLs();
            const altNavigationModel = getManager().navigation.createNavigationModel(getManager().navigation.model.routeIDs);
            const currentPath = getManager().navigation.model.href
            if (altNavigationModel.href !== currentPath)
            {
                dispatchRedirectTo(altNavigationModel.href);
            }
        }
    }

    return <>
        <PostAddEditForm
            routeProps={props}
            ref={formRef}
            onSubmit={onSubmit}
            postType={postType}
            organisationID={organisationID}
            postID={postID}
        />
    </>
}

export default PostEditPage;